<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-GDPR",
  path: "gdpr",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
